export default __webpack_public_path__ + "static/media/blog2.1ca5fdeb.png";